<script setup lang="ts">
import { useToasts } from '~/composables/useToasts'

const { toast, closeToast } = useToasts()

const isSuccess = computed(() => toast.value?.status === 'SUCCESS')
const isError = computed(() => toast.value?.status === 'ERROR')

const route = useRoute()
watch(route, () => {
  closeToast()
}, { immediate: true })
</script>

<template>
  <Teleport
    to="body"
    v-if="toast?.message"
  >
    <div
      class="toast-background"
      :class="{success: isSuccess, error: isError}"
    >
      <FontAwesomeIcon
        :icon="isSuccess ? 'check-circle' : isError ? 'exclamation-circle' : ''"
      />
      <span class="text-base leading-[18px]">{{ toast.message }}</span>
      <button
        @click="closeToast"
        class="ml-auto flex items-center justify-center p-0"
      >
        <FontAwesomeIcon
          icon="times"
        />
      </button>
    </div>
  </Teleport>
</template>

<style scoped lang="scss">
.toast-background {
  @apply z-[6000] font-bold fixed top-8 right-8 w-[304px] border rounded-2xl flex gap-x-2 items-start p-4 backdrop-blur-md shadow-[0_16px_32px_0];

  @include sm {
    @apply top-4 right-4 w-[calc(100%-2rem)];
  }

  &.success {
    @apply bg-explorer-teal/10 border-explorer-teal text-explorer-teal shadow-explorer-teal/20;
  }

  &.error {
    @apply bg-explorer-red/10 border-explorer-red text-explorer-red shadow-explorer-red/20;
  }
}
</style>